// extracted by mini-css-extract-plugin
module.exports = {"content":"Layout_content__3aNSB"};